import { buildApiUrl } from "../../services/apiConfig";

class PoolManagementService {
  constructor() {
    this.token = localStorage.getItem('auth_token') || 'your-auth-token';
    this.baseUrl = buildApiUrl('GROUPS');
  }

  // Customer-related API calls
  async getCustomers(searchTerm = '', filterGroup = 'all') {
    try {
      const params = new URLSearchParams();
      if (searchTerm) params.append('search', searchTerm);
      if (filterGroup !== 'all') params.append('group_id', filterGroup);

      const response = await fetch(`${this.baseUrl}/customers/?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  }

  // Group-related API calls
  async getGroups(searchTerm = '') {
    try {
      const params = new URLSearchParams();
      if (searchTerm) params.append('search', searchTerm);

      const response = await fetch(`${this.baseUrl}/groups/?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching groups:', error);
      throw error;
    }
  }

  async getGroupAdvisors(groupId) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/advisors/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error fetching advisors for group ${groupId}:`, error);
      throw error;
    }
  }

  async createGroup(groupData) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(groupData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating group:', error);
      throw error;
    }
  }

  async updateGroup(groupId, groupData) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(groupData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating group:', error);
      throw error;
    }
  }

  async deleteGroup(groupId) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting group:', error);
      throw error;
    }
  }

  async assignAdvisorToGroup(groupId, advisorId) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/advisors/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ advisor_id: advisorId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error assigning advisor to group:', error);
      throw error;
    }
  }

  async removeAdvisorFromGroup(groupId, advisorId) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/advisors/${advisorId}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error removing advisor from group:', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await fetch(`${this.baseUrl}/stats`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  }

  async getAdvisors(searchTerm = '') {
    try {
      const response = await fetch(`${this.baseUrl}/advisors/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching advisors:', error);
      throw error;
    }
  }

  async assignCustomerToGroup(groupId,customerId) {
    try {
      console.log(`${this.baseUrl}/groups/${groupId}/customers/`);
      console.log({customer_id: customerId});
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/customers/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({customer_id: customerId}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error assigning customer to group:', error);
      throw error;
    }
  }
  async removeAdvisorFromGroup(groupId, advisorId) {
    try {
      const response = await fetch(`${this.baseUrl}/groups/${groupId}/advisors/${advisorId}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error removing advisor from group:', error);
      throw error;
    }
  }
}

export default new PoolManagementService();